import React, { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";

import ErrorBoundary from "../../../utils/ErrorBoundary";

//Elements
import Text from "../Text/Text";
import NestedColumn from "../Column/NestedColumn/NestedColumn";
import BUTTON from "../Button/Button";
import Image from "../Image/Image";
import VideoElement from "../Video/Video";
import Form from "../Form/Form";
import File from "../File/File";
import TABLEEditor from "../TABLE/Table";
import HTMLEditor from "../HTML/Html";
import TimerElement from "../Timer/Timer";
import Line from "../Line/Line";
import { DragAndDropContext } from "../../../context/DragAndDropContext";
import Draggable from "../../../containers/Draggable/Draggable";
import AccordionItemSettings from "./AccordionItemSettings";
import NestedAccordion from "../Accordion/NestedAccordion/NestedAccordion";
import AddToolButton from "../../Tool/AddToolButton/AddToolButton";

import * as UTILS from "../../../utils/Utils";

const AccordionBody = ({
  addedIndex,
  col,
  colIndex,
  columns,
  mobileView,
  className,
  element,
  onChangeHandler,
  ID,
  showAddElement,
  disableRowTool,
  tool,
  preset,
  preventDrop,
  resizeID,
  onAddElementorColumnInColumn,
  onAddElementorColumn,
  pagesList,
  cloneElement,
  deleteElement,
  modalUpload,
  selectedFile,
  loaded,
  videoClicked,
  videoDataID,
  layout,
  addVideo,
  videoOption,
  openAccordionItemSettingsIndex,
  toggleAccordionItemSettings,
  userId,
  sessionId,
  addRemoveColumn,
}) => {
  const {
    onDrag,
    onDragOver,
    onDragEnter,
    dragOverElement,
    barLocation,
    dragOverParent,
    dragOverColumnIndex,
  } = useContext(DragAndDropContext);

  const {
    columnGap,
    canvasRowsPaddingUnit,
    canvasRowsPadding,
    canvasRowsPaddingMobile,
    removeColumn,
    toggleUploadPopup,
  } = useSelector((state) => state.present.canvasStyle);
const {selectedFont} = useSelector((state) => state.present);
  return (
    <div
      onDragOver={(e) => {
        onDragOver(e);
      }}
      onDragEnter={(e) => {
        onDragEnter(e, null, null, element, colIndex);
      }}
      className={
        "accordion-body column " +
        (columns[col].length === 0 ? "noContent" : "") +
        (dragOverParent &&
        (dragOverParent.id === element.id) & (dragOverColumnIndex === colIndex)
          ? " draggedOver"
          : "")
      }
      style={
        mobileView
          ? {
              height: "fit-content",
              position: "relative",
              backgroundColor: `rgba(${element.columnSettings[col].itemBody.mobileStyle.backgroundColor.r},${element.columnSettings[col].itemBody.mobileStyle.backgroundColor.g},${element.columnSettings[col].itemBody.mobileStyle.backgroundColor.b},${element.columnSettings[col].itemBody.mobileStyle.backgroundColor.a})`,
              paddingTop:
                element.columnSettings[col].itemBody.mobileStyle.paddingTop +
                element.columnSettings[col].itemBody.paddingUnit,
              paddingBottom:
                element.columnSettings[col].itemBody.mobileStyle.paddingBottom +
                element.columnSettings[col].itemBody.paddingUnit,
              paddingRight:
                element.columnSettings[col].itemBody.mobileStyle.paddingRight +
                element.columnSettings[col].itemBody.paddingUnit,
              paddingLeft:
                element.columnSettings[col].itemBody.mobileStyle.paddingLeft +
                element.columnSettings[col].itemBody.paddingUnit,
              borderBottomRightRadius:
                element.columnSettings[col].itemHeader.mobileStyle
                  .borderRadius + "px",
              borderBottomLeftRadius:
                element.columnSettings[col].itemHeader.mobileStyle
                  .borderRadius + "px",
            }
          : {
              height: "fit-content",
              position: "relative",
              backgroundColor: `rgba(${element.columnSettings[col].itemBody.desktopStyle.backgroundColor.r},${element.columnSettings[col].itemBody.desktopStyle.backgroundColor.g},${element.columnSettings[col].itemBody.desktopStyle.backgroundColor.b},${element.columnSettings[col].itemBody.desktopStyle.backgroundColor.a})`,
              paddingTop:
                element.columnSettings[col].itemBody.desktopStyle.paddingTop +
                element.columnSettings[col].itemBody.paddingUnit,
              paddingBottom:
                element.columnSettings[col].itemBody.desktopStyle
                  .paddingBottom +
                element.columnSettings[col].itemBody.paddingUnit,
              paddingRight:
                element.columnSettings[col].itemBody.desktopStyle.paddingRight +
                element.columnSettings[col].itemBody.paddingUnit,
              paddingLeft:
                element.columnSettings[col].itemBody.desktopStyle.paddingLeft +
                element.columnSettings[col].itemBody.paddingUnit,
              borderBottomRightRadius:
                element.columnSettings[col].itemHeader.desktopStyle
                  .borderRadius + "px",
              borderBottomLeftRadius:
                element.columnSettings[col].itemHeader.desktopStyle
                  .borderRadius + "px",
            }
      }
    >
      <AccordionItemSettings
        className="accordionItem-Settings"
        element={element}
        accordionId={ID}
        accordionItem={col}
        col={col}
        openAccordionItemSettingsIndex={openAccordionItemSettingsIndex}
        toggleAccordionItemSettings={toggleAccordionItemSettings}
      />

      {columns[col].map((colmItem, colIndex) => {
        return (
          <Draggable
            element={colmItem}
            classlist={
              "item " +
              (colmItem.data === "Row"
                ? " rowMain"
                : colmItem.data === "Accordion"
                ? " accordionMain"
                : "")
            }
            style={
              dragOverElement &&
              (dragOverElement.id === colmItem.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === colmItem.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            tool={UTILS.tool}
            key={"draggable-" + colmItem.id}
            onAddElementorColumn={onAddElementorColumn}
            onAddElementorColumnInColumn={onAddElementorColumnInColumn}
            mobileView={mobileView}
            ID={colmItem.id}
            dataAttr={colmItem.title}
            onDrag={(e) => {
              onDrag(e, colmItem, element, colIndex);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, colmItem, colIndex, element);
            }}
          >
            {colmItem.data == "Accordion" ? (
              <ErrorBoundary>
                <NestedAccordion
                  userID={userId}
                  sessionID={sessionId}
                  preset={preset}
                  mobileView={mobileView}
                  mobileAlign={colmItem.mobileAlign ? colmItem.mobileAlign : ""}
                  label={colmItem.label}
                  pagesList={pagesList}
                  Link={colmItem.link}
                  element={colmItem}
                  LinkName={colmItem.linkname}
                  LinkType={colmItem.linktype}
                  LinkOpen={colmItem.linkopen}
                  selectedFont={selectedFont}
                  UseSocial={colmItem.use_social}
                  keyID={colIndex}
                  ID={colmItem.id}
                  srcID={colmItem.srcID}
                  src={colmItem.src}
                  style={colmItem.style}
                  edit={colmItem.edit}
                  onAddElementorColumnInColumn={onAddElementorColumnInColumn}
                  onAddElementorColumn={onAddElementorColumn}
                  deleteElement={deleteElement}
                  URL={colmItem.href}
                  cloneElement={cloneElement}
                />
              </ErrorBoundary>
            ) : colmItem.data == "IMAGE" ? (
              <ErrorBoundary>
                <Image
                  userID={userId}
                  sessionID={sessionId}
                  mobileView={mobileView}
                  mobileAlign={colmItem.mobileAlign ? colmItem.mobileAlign : ""}
                  label={colmItem.label}
                  pagesList={pagesList}
                  Link={colmItem.link}
                  element={colmItem}
                  LinkName={colmItem.linkname}
                  LinkType={colmItem.linktype}
                  LinkOpen={colmItem.linkopen}
                  UseSocial={colmItem.use_social}
                  imageMarginUnit={colmItem.style.imageMarginUnit}
                  imageWidthUnit={colmItem.style.imageWidthUnit}
                  marginTop={colmItem.style.marginTop || 0}
                  marginRight={colmItem.style.marginRight || 0}
                  marginBottom={colmItem.style.marginBottom || 0}
                  marginLeft={colmItem.style.marginLeft || 0}
                  keyID={colIndex}
                  ID={colmItem.id}
                  srcID={colmItem.srcID}
                  src={colmItem.src}
                  style={colmItem.style}
                  edit={colmItem.edit}
                  deleteElement={deleteElement}
                  width={colmItem.style.maxWidth}
                  height={colmItem.style.height}
                  radius={colmItem.style.borderRadius}
                  float={colmItem.style.float}
                  opacity={colmItem.style.opacity}
                  URL={colmItem.href}
                  cloneElement={cloneElement}
                />
              </ErrorBoundary>
            ) : colmItem.data == "VIDEO" ? (
              <ErrorBoundary>
                <VideoElement
                  userID={userId}
                  sessionID={sessionId}
                  marginTop={colmItem.style.marginTop || 0}
                  marginBottom={colmItem.style.marginBottom || 0}
                  videoMarginUnit={colmItem.style.videoMarginUnit}
                  videoWidthUnit={colmItem.style.videoWidthUnit}
                  label={colmItem.label}
                  element={colmItem}
                  videoURL_ADDRESS={
                    colmItem.vimeoTHUMB
                      ? colmItem.vimeoTHUMB
                      : colmItem.youtubeTHUMB
                      ? colmItem.youtubeTHUMB
                      : ""
                  }
                  vimeoID={colmItem.vimeoID || null}
                  youtubeID={colmItem.youtubeID || null}
                  vimeoTHUMB={colmItem.vimeoTHUMB || null}
                  youtubeTHUMB={colmItem.youtubeTHUMB || null}
                  video_url={colmItem.video_url || null}
                  showChaptersToggle={colmItem.showChaptersToggle}
                  if_src={colmItem.src}
                  ID={colmItem.id}
                  addVideo={() => addVideo(colmItem.id, colmItem.videoID)}
                  videoOption={() => {
                    videoOption(colmItem.id);
                  }}
                  deleteElement={deleteElement}
                  VideoWidth={colmItem.style.maxWidth}
                  srcID={colmItem.srcID}
                  editEnable={colmItem.edit}
                  modalUpload={modalUpload}
                  selectedFile={selectedFile}
                  toggleUploadPopup={toggleUploadPopup}
                  onChangeHandler={onChangeHandler}
                  loaded={loaded}
                  videoClicked={videoClicked}
                  videoDataID={videoDataID}
                  autoplay={colmItem.autoplay}
                  modal={colmItem.modal}
                  chapters={colmItem.chapters}
                  control={colmItem.control}
                  layout={layout}
                  cloneElement={cloneElement}
                />
              </ErrorBoundary>
            ) : colmItem.data == "Line" ? (
              <ErrorBoundary>
                <Line
                  display={colmItem.style.display}
                  margin={colmItem.style.margin}
                  element={colmItem}
                  lineMarginUnit={colmItem.style.lineMarginUnit}
                  label={colmItem.label}
                  marginTop={colmItem.style.marginTop}
                  marginRight={colmItem.style.marginRight}
                  marginBottom={colmItem.style.marginBottom}
                  marginLeft={colmItem.style.marginLeft}
                  borderColor={colmItem.style.borderColor}
                  borderWidth={colmItem.style.borderWidth}
                  backgroundColor={colmItem.style.backgroundColor}
                  style={colmItem.style}
                  preset={preset}
                  width={colmItem.style.width}
                  ID={colmItem.id}
                  deleteElement={deleteElement}
                  cloneElement={cloneElement}
                />
              </ErrorBoundary>
            ) : colmItem.data == "FILE" ? (
              <ErrorBoundary>
                <File
                  userID={userId}
                  sessionID={sessionId}
                  marginTop={colmItem.style.marginTop || 0}
                  marginBottom={colmItem.style.marginBottom || 0}
                  fileMarginUnit={colmItem.style.fileMarginUnit}
                  label={colmItem.label}
                  fileWidthUnit={colmItem.style.fileWidthUnit}
                  element={colmItem}
                  keyID={colIndex}
                  ID={colmItem.id}
                  thumbID={colmItem.thumbID}
                  thumb={colmItem.thumb}
                  files={colmItem.files}
                  deleteElement={deleteElement}
                  cloneElement={cloneElement}
                  style={colmItem.style}
                  opacity={colmItem.style.opacity}
                  radius={colmItem.style.borderRadius}
                  width={colmItem.style.maxWidth}
                  float={colmItem.style.float}
                />
              </ErrorBoundary>
            ) : colmItem.data == "TIMER" ? (
              <ErrorBoundary>
                <TimerElement
                  ID={colmItem.id}
                  label={colmItem.label}
                  date={colmItem.date}
                  size={colmItem.size}
                  patternStyle={colmItem.patternStyle}
                  float={colmItem.style.float}
                  timerMarginUnit={colmItem.style.timerMarginUnit}
                  fontFamily={colmItem.style.fontFamily || "Open Sans"}
                  marginTop={colmItem.style.marginTop}
                  marginRight={colmItem.style.marginRight}
                  marginBottom={colmItem.style.marginBottom}
                  marginLeft={colmItem.style.marginLeft}
                  margin={colmItem.style.margin}
                  deleteElement={deleteElement}
                  cloneElement={cloneElement}
                />
              </ErrorBoundary>
            ) : colmItem.data == "TABLE" ? (
              <ErrorBoundary>
                <TABLEEditor
                  mobileView={mobileView}
                  element={colmItem}
                  label={colmItem.label}
                  selectedFont={selectedFont}
                  preset={preset}
                  pagesList={pagesList}
                  ID={colmItem.id}
                  edit={colmItem.edit}
                  content={colmItem.content}
                  fontFamily={
                    (colmItem.style && colmItem.style.fontFamily) || "Open Sans"
                  }
                  mobileContent={colmItem.mobileStyle.content}
                  desktopContent={colmItem.desktopStyle.content}
                  isMirrored={colmItem.isMirrored}
                  deleteElement={deleteElement}
                  cloneElement={cloneElement}
                  style={colmItem.style}
                  tableMobileUnit={colmItem.tableMobileUnit}
                  tableDesktopUnit={colmItem.tableDesktopUnit}
                />
              </ErrorBoundary>
            ) : colmItem.data == "HTML" ? (
              <ErrorBoundary>
                <HTMLEditor
                  label={colmItem.label}
                  mobileView={mobileView}
                  element={colmItem}
                  pagesList={pagesList}
                  ID={colmItem.id}
                  edit={colmItem.edit}
                  content={colmItem.content}
                  fontFamily={
                    (colmItem.style && colmItem.style.fontFamily) || "Open Sans"
                  }
                  selectedFont={selectedFont}
                  deleteElement={deleteElement}
                  cloneElement={cloneElement}
                  style={colmItem.style}
                />
              </ErrorBoundary>
            ) : colmItem.data == "BUTTON" ? (
              <ErrorBoundary>
                <BUTTON
                  label={colmItem.label}
                  mobileView={mobileView}
                  pagesList={pagesList}
                  Link={colmItem.link}
                  LinkName={colmItem.linkname}
                  LinkType={colmItem.linktype}
                  element={colmItem}
                  LinkOpen={colmItem.linkopen}
                  UseSocial={colmItem.use_social}
                  fullWidth={colmItem.style.width || "auto"}
                  deleteElement={deleteElement}
                  cloneElement={cloneElement}
                  ID={colmItem.id}
                  style={colmItem.style}
                  mobileAlignment={colmItem.mobileAlignment || "none"}
                  // IDELE={id}
                  fontName={colmItem.style.fontFamily}
                  fontSize={colmItem.style.fontSize}
                  borderRadius={colmItem.style.borderRadius}
                  fontWeight={colmItem.style.fontWeight || "normal"}
                  borderWidthVal={colmItem.style.borderWidth}
                  borderWidth={colmItem.style.borderWidth}
                  paddingTop={colmItem.style.paddingTop}
                  paddingRight={colmItem.style.paddingRight}
                  paddingBottom={colmItem.style.paddingBottom}
                  paddingLeft={colmItem.style.paddingLeft}
                  btnPaddingUnit={colmItem.style.btnPaddingUnit}
                  btnMarginUnit={colmItem.style.btnMarginUnit}
                  marginTop={colmItem.style.marginTop}
                  marginRight={colmItem.style.marginRight}
                  marginBottom={colmItem.style.marginBottom}
                  marginLeft={colmItem.style.marginLeft}
                  floatVal={colmItem.style.float}
                  buttonURL={colmItem.buttonURL}
                  content={colmItem.content}
                  keyID={colmItem.id}
                  editVal={colmItem.edit}
                  googleFonts={UTILS.googleFonts}
                  editStatus={colmItem.edit}
                  normalTextColor={
                    colmItem.normalBtn.txtColor.rgb || {
                      r: 255,
                      g: 255,
                      b: 255,
                      a: 1,
                    }
                  }
                  normalBtnBg={
                    colmItem.normalBtn.btnBG.rgb || {
                      r: 12,
                      g: 50,
                      b: 84,
                      a: 1,
                    }
                  }
                  normalBtnBorder={
                    colmItem.normalBtn.btnBorder.rgb || {
                      r: 12,
                      g: 50,
                      b: 84,
                      a: 1,
                    }
                  }
                  hoverBtnTextColor={
                    colmItem.hoverBtn.txtColor.rgb || {
                      r: 255,
                      g: 255,
                      b: 255,
                      a: 1,
                    }
                  }
                  hoverBtnBgColor={
                    colmItem.hoverBtn.btnBg.rgb || {
                      r: 0,
                      g: 98,
                      b: 204,
                      a: 1,
                    }
                  }
                  hoverBorder={
                    colmItem.hoverBtn.btnBorder.rgb || {
                      r: 12,
                      g: 50,
                      b: 84,
                      a: 1,
                    }
                  }
                />
              </ErrorBoundary>
            ) : colmItem.data == "TEXT" ? (
              <ErrorBoundary>
                <Text
                  selectedFont={selectedFont}
                  preset={preset}
                  mobileView={mobileView}
                  mobileAlign={colmItem.mobileAlign ? colmItem.mobileAlign : ""}
                  desktopAlign={
                    colmItem.desktopAlign ? colmItem.desktopAlign : ""
                  }
                  label={colmItem.label}
                  pagesList={pagesList}
                  keyID={colmItem.id}
                  itemIndex={colIndex}
                  ID={colmItem.id}
                  element={colmItem}
                  editVal={colmItem.edit}
                  googleFonts={UTILS.googleFonts}
                  deleteElement={deleteElement}
                  editOption={colmItem.edit}
                  lineHeightVal={colmItem.style.lineHeight}
                  maxWidth={colmItem.maxWidth}
                  // marginLeft={colmItem.marginLeft}
                  textContent={colmItem.text}
                  cloneElement={cloneElement}
                  fontSize={colmItem.style.fontSize}
                  fontName={colmItem.style.fontFamily}
                  marginTop={colmItem.style.marginTop || 0}
                  marginRight={colmItem.style.marginRight || 0}
                  marginBottom={colmItem.style.marginBottom || 0}
                />
              </ErrorBoundary>
            ) : colmItem.data == "FORM" ? (
              <ErrorBoundary>
                <Form
                  googleFonts={UTILS.googleFonts}
                  Layout={layout}
                  FormObj={colmItem}
                  formArray={colmItem.fields}
                  ID={colmItem.id}
                  label={colmItem.label}
                  width={colmItem.style.width}
                  borderWidth={colmItem.style.borderWidth}
                  borderStyle={colmItem.style.borderStyle}
                  borderRadius={colmItem.style.borderRadius}
                  borderColor={colmItem.style.borderColor}
                  formMarginUnit={colmItem.style.formMarginUnit}
                  fontFamily={colmItem.style.fontFamily || "Open Sans"}
                  marginTop={colmItem.style.marginTop || 0}
                  marginRight={colmItem.style.marginRight || 0}
                  marginBottom={colmItem.style.marginBottom || 0}
                  marginLeft={colmItem.style.marginLeft || 0}
                  backgroundColor={colmItem.style.backgroundColor}
                  color={colmItem.style.color}
                  email={colmItem.email}
                  deleteElement={deleteElement}
                  cloneElement={cloneElement}
                />
              </ErrorBoundary>
            ) : colmItem.data == "Row" ? (
              <NestedColumn
                googleFonts={UTILS.googleFonts}
                selectedFont={selectedFont}
                preset={preset}
                showAddElement={showAddElement}
                tool={tool}
                preventDrop={preventDrop}
                pagesList={pagesList}
                mobileView={mobileView}
                ID={colmItem.id}
                onAddElementorColumn={onAddElementorColumn}
                onAddElementorColumnInColumn={onAddElementorColumnInColumn}
                deleteElement={deleteElement}
                cloneElement={cloneElement}
                deskWidth={colmItem.deskWidth}
                index={colIndex}
                label={colmItem.label}
                                      element={colmItem}
                resizeID={resizeID}
                addedIndex={addedIndex}
                bgRepeat={
                  colmItem.rowStyle && colmItem.rowStyle.bgRepeat
                    ? colmItem.rowStyle.bgRepeat
                    : "no-repeat"
                }
                bgSize={
                  colmItem.rowStyle && colmItem.rowStyle.bgSize
                    ? colmItem.rowStyle.bgSize
                    : "cover"
                }
                rowStyle={colmItem.rowStyle ? colmItem.rowStyle : null}
                rowBg={
                  colmItem.rowStyle && colmItem.rowStyle.rowBg
                    ? colmItem.rowStyle.rowBg
                    : undefined
                }
                rowBgColor={
                  colmItem.rowStyle && colmItem.rowStyle.rowBgColor
                    ? colmItem.rowStyle.rowBgColor
                    : "transparent"
                }
                rowBorderColor={
                  colmItem.rowStyle && colmItem.rowStyle.rowBorderColor
                    ? colmItem.rowStyle.rowBorderColor
                    : "#000000"
                }
                borderWidth={
                  colmItem.rowStyle && colmItem.rowStyle.borderWidth
                    ? colmItem.rowStyle.borderWidth
                    : "0"
                }
                rowCroppedBg={
                  colmItem.rowStyle && colmItem.rowStyle.croppedBg !== null
                    ? colmItem.rowStyle.croppedBg
                    : undefined
                }
                rowBgWidth={
                  colmItem.rowStyle && colmItem.rowStyle.bgWidth
                    ? colmItem.rowStyle.bgWidth
                    : undefined
                }
                rowOpacity={
                  colmItem.rowStyle && colmItem.rowStyle.opacity
                    ? colmItem.rowStyle.opacity
                    : "1.0"
                }
                columnGap={columnGap}
                canvasRowsPaddingUnit={canvasRowsPaddingUnit}
                canvasRowsPadding={canvasRowsPadding}
                canvasRowsPaddingMobile={canvasRowsPaddingMobile}
                columns={colmItem.columns}
                addRemoveColumn={addRemoveColumn}
                removeColumn={removeColumn}
                itemID={ID}
                toggleUploadPopup={toggleUploadPopup}
                onChangeHandler={onChangeHandler}
                modalUpload={modalUpload}
                selectedFile={selectedFile}
                loaded={loaded}
                videoClicked={videoClicked}
                videoDataID={videoDataID}
                layout={layout}
                addVideo={addVideo}
                videoOption={videoOption}
              />
            ) : null}
          </Draggable>
        );
      })}

      {columns[col].length === 0 ? (
        <AddToolButton
          showAddElement={showAddElement}
          disableAccordionTool={true}
          disableRowTool={disableRowTool}
          tool={UTILS.tool}
          ID={ID}
          block={false}
          columnNumber={col}
          mobileView={mobileView}
          forColumn={true}
          onAddElementorColumnInColumn={onAddElementorColumnInColumn}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default AccordionBody;
